/* globalmodule */
define('../src/sublayouts/m70-status-tracker/m70-status-tracker',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var StatusTracker = function($component) {

        this.$component = $component;

        return this;
    };

    StatusTracker.prototype.init = function() {
        var _this = this;

        if (!_this.$component.hasClass('m70-status-tracker-new') && !_this.$component.hasClass('m70-status-tracker-vertical')) {

            _this.currentStep = parseInt(_this.$component.attr('data-current-step'));
            _this.$progressbar = _this.$component.find('[data-m70-progressbar]');
            _this.$steps = _this.$component.attr('data-steps');
            _this.$error = _this.$component.attr('data-has-error');

            $(window).off('reinit_m70').on('reinit_m70', function() {
                _this.init();
            });

            _this.build();
            _this.count();
            _this.current();

            $(window).on('resize', function() {
                _this.count();
            });
        };

        this.new();

        $(window).on('resize', function() {
            _this.new();
        });
    };

    StatusTracker.prototype.build = function() {
        var _this = this,
            steps = _this.$steps.split(',');

        $('.m70-status-tracker__progressbar').html('');

        for (var i = 0; i < steps.length; i++) {
            $('.m70-status-tracker__progressbar').each(function() {
                $(this).append('<div class="m70-status-tracker__step-wrapper"><div class="m70-status-tracker__step-aesth icon-tick"></div><div class="m70-status-tracker__step-text">' + steps[i] + '</div></div>');
            });
        }
    };

    StatusTracker.prototype.count = function() {
        var _this = this,
            count = $('.m70-status-tracker__progressbar').find('.m70-status-tracker__step-wrapper').length,
            $parent = $('.m70-status-tracker__progressbar'),
            offset = (20 / $('.m70-status-tracker__progressbar').width()) * 100;

        //margin = 

        $parent.find('.m70-status-tracker__step-wrapper').each(function(index) {
            $(this).css('width', (100 / count).toString() + '%')
        });

        if (!utils.isRTL()) {
            $('.m70-status-tracker__progressbar').css('padding-left', ((50 / count) + offset).toString() + '%')
            $parent.find('.m70-status-tracker__step-text').each(function() {
                $(this).css('right', (($parent.find('.m70-status-tracker__step-aesth').width() - 24) / 2).toString() + 'px');
            });
        } else {
            $('.m70-status-tracker__progressbar').css('padding-right', ((50 / count) + offset).toString() + '%')
            $parent.find('.m70-status-tracker__step-text').each(function() {
                $(this).css('left', (($parent.find('.m70-status-tracker__step-aesth').width() - 24) / 2).toString() + 'px');
            });
        }

    };

    StatusTracker.prototype.current = function() {
        var _this = this,
            step = _this.currentStep;

        $('.m70-status-tracker__progressbar').each(function() {
            $(this).find('.m70-status-tracker__step-wrapper').each(function(index) {
                if (index < step) {
                    $(this).addClass('m70-status-tracker__step-wrapper--active');
                };

                if (index == step - 1) {
                    $(this).find('.m70-status-tracker__step-aesth').css('border-top', '5px solid #DBDBDB');
                    if (_this.$error == 'true') {
                        $(this).removeClass('m70-status-tracker__step-wrapper--active').addClass('m70-status-tracker__step-wrapper--error');
                        $(this).find('.m70-status-tracker__step-aesth').removeClass('icon-tick').addClass('icon-cancel');
                    };
                }
            });
        });

    };

    StatusTracker.prototype.new = function() {
        var _this = this,
            $items = this.$component.find('.m70-status-tracker--item'),
            width = (100 / this.$component.find('.m70-status-tracker--item').length) - .5;

        if (_this.$component.hasClass('m70-status-tracker-new') && $(window).width() > 1024) {
            $items.each(function() {
                $(this).css('width', width.toString() + '%');
            });
        } else {
            $items.each(function() {
                $(this).attr('style', '');
            });
        }
    }

    return StatusTracker;

});
